import { render, staticRenderFns } from "./sitePermit.vue?vue&type=template&id=0a330b13&"
import script from "./sitePermit.vue?vue&type=script&lang=js&"
export * from "./sitePermit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports